class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    const togglePredictiveSearchClass = (isFocused) => {
      document.body.classList.toggle('open-predictive', isFocused);
      document.body.classList.toggle('no-scroll', isFocused);
    };

    this.input.addEventListener('focus', () =>
      togglePredictiveSearchClass(true)
    );
    // this.input.addEventListener('blur', () =>
    //   togglePredictiveSearchClass(false)
    // );

    this.onChange();
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    const url = searchTerm.length
      ? `/search/suggest?q=${searchTerm}&section_id=predictive-search`
      : '/?section_id=predictive-search-default';
    const template = searchTerm.length ? '' : '-default';

    this.getSearchResults(url, template);
  }

  getSearchResults(url, template) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            `#shopify-section-predictive-search${template}`
          ).innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        // Add href to view all results button
        if (document.querySelector('.view-search-results-btn')) {
          document
            .querySelector('.view-search-results-btn')
            .setAttribute(
              'href',
              `/search?q=${this.input.value.trim().replace(' ', '+')}`
            );
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();

//     this.input = this.querySelector('input[type="search"]');
//     this.predictiveSearchResults = this.querySelector('#predictive-search');

//     this.input.addEventListener('focus', this.open.bind(this));

//     this.input.addEventListener(
//       'input',
//       this.debounce((event) => {
//         this.onChange(event);
//       }, 300).bind(this)
//     );

//     this.onChange();
//   }

//   onChange() {
//     const searchTerm = this.input.value.trim();
//     const url = searchTerm.length
//       ? `/search/suggest?q=${searchTerm}&section_id=predictive-search`
//       : '/?section_id=predictive-search-default';
//     const template = searchTerm.length ? '' : '-default';

//     this.getSearchResults(url, template);
//   }

//   getSearchResults(url, template) {
//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, 'text/html')
//           .querySelector(
//             `#shopify-section-predictive-search${template}`
//           ).innerHTML;
//         this.predictiveSearchResults.innerHTML = resultsMarkup;

//         // Add href to view all results button
//         if (document.querySelector('.view-search-results-btn')) {
//           document
//             .querySelector('.view-search-results-btn')
//             .setAttribute(
//               'href',
//               `/search?q=${this.input.value.trim().replace(' ', '+')}`
//             );
//         }

//         // this.open();
//       })
//       .catch((error) => {
//         this.close();
//         throw error;
//       });
//   }

//   open() {
//     this.predictiveSearchResults.style.display = 'block';
//   }

//   close() {
//     this.predictiveSearchResults.style.display = 'none';
//   }

//   debounce(fn, wait) {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn.apply(this, args), wait);
//     };
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);
